module.exports = __webpack_public_path__ + "static/media/background.5e191f5a.jpg";